import React from 'react';
import '../styles/ProfileEditScreen.css';

function ProfileEditScreen({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="profile-edit-screen-overlay" onClick={onClose}>
      <div className="profile-edit-screen" onClick={(e) => e.stopPropagation()}>
        <div className="profile-edit-screen-header">
          <button 
            className="profile-edit-screen-back"
            onClick={onClose}
            aria-label="Back"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h2 className="profile-edit-screen-title">Edit Profile</h2>
          <div style={{ width: '40px' }} /> {/* Spacer for centering */}
        </div>
        <div className="profile-edit-screen-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default ProfileEditScreen;
